export default "__VITE_PUBLIC_ASSET__b37b3f39__"